



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { StreakCalendarDay } from 'frontend/types';

@Component({})
export default class StreakCalendar extends Vue {
  @Prop(Array) readonly calendarDays!: StreakCalendarDay[];
  @Prop(Boolean) readonly mobile?: boolean;
  @Prop(Boolean) readonly narrow!: boolean;
}
